export default __webpack_public_path__ + "static/demographics2-f8af31083af616af99f36e4df2ff7346.png";